<!--
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-09-01 11:29:25
 * @LastEditors: knx-xc
--> 

<template>
  <div class="custmer">
    <div class="customer-title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>友情链接&合作伙伴</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="customer-group">
      <div>
        <el-button-group>
          <el-button v-for="(item,index) of statusList" :key="index" :type=" index == statusIndex ? 'primary' : '' " v-text='item.name' @click="switchStatus(index)"></el-button>
        </el-button-group>
      </div>
      <div>
        <el-input placeholder="请输入名称" v-model="params.search_val" class="input-with-select" @keyup.enter.native="onSearch()">
          <el-button slot="append" icon="el-icon-search" @click="onSearch()"></el-button>
        </el-input>
        <el-button type="primary" style="margin-left:10px" @click="onAdd() ">新增</el-button>
      </div>
    </div>
    <div class="customer-content" v-loading="loadingData" v-cloak>
      <el-table :data="list" style="width: 100%" class="table" header-row-class-name="outer-header">
        <el-table-column prop="name" label="名称" align="center">
          <template slot-scope="scope">
            <p v-text="scope.row.name" class="line-2"></p>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="页面链接" align="center">
        </el-table-column>
        <el-table-column prop="img" label="图片/名称" align="center" >
          <template slot-scope="scope">
            <el-image v-if="scope.row.type == 1 "  style="width: 200px; height: 100px" :src="scope.row.img" :preview-src-list="[scope.row.img]">
            </el-image>
            <el-tag v-else type="success" v-text="scope.row.name"></el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pageName" label="所属页面" align="center">
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center">
          <template slot-scope="scope">
            <p v-text="scope.row.type === '0' ? '友情链接' :'合作伙伴' "></p>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="添加时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="onEdit(scope.$index)" v-text="'修改'"></el-button>
            <el-button type="danger" size="small" @click="onDel(scope.$index)" v-text="'删除'"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-show="params.total > params.limit">
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[20,30,40,50]" :page-size="params.limit" layout="total, sizes, prev, pager, next" :total="params.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="form.id ? '新增' :'修改'" :visible.sync="dialogVisible" width="40%" center :close-on-click-modal=false :before-close='beforeClose'>
      <el-form label-position="right" label-width="100px" ref="addForm" :model="form" :rules="rules">
        <el-form-item prop="name" label="链接名称">
          <el-input v-model="form.name" placeholder='请输入链接名称' clearable></el-input>
        </el-form-item>
        <el-form-item prop="type" label="链接类型">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option label="友情链接" value=0>
            </el-option>
            <el-option label="合作伙伴" value=1>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="page" label="所属页面">
          <el-select v-model="form.page" placeholder="请选择页面">
            <el-option v-for="item in pageSelectList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="url" label="跳转链接">
          <el-input v-model="form.url" placeholder='请输入跳转链接' clearable></el-input>
        </el-form-item>
        <el-form-item prop="img" label="logo图片" v-if="form.type == 1">
          <Upload v-model="form.img" @update="onImageChange" :text="'logo图片'">
            <p style="font-size:12px;height:16px;line-hieght:16px;"  v-text="'建议尺寸(204*72)'"> </p>
          </Upload>
        </el-form-item>
        <el-form-item label-width="0px">
          <div style='text-align:center;'>
            <el-button type="primary" v-if="form.id" @click="onUpdate()">修改</el-button>
            <el-button type="primary" v-else @click="onSave()">添加</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>
 
<script>
import { friendly_list, friendly_info, friendly_save, friendly_update, friendly_delete } from "@/request/api.admin/friendlyLink";
import { getPageSelectList } from "@/request/api.admin/common";
import Upload from "../../../components/admin/UploadImage";
export default {
  name: '',
  components: { Upload },
  data() {
    return {
      loadingData: true,
      dialogVisible: false,
      params: {
        search_val: '',
        type: '',
        page: 1,
        limit: 20,
        total: 0,
      },
      statusIndex: 0,
      statusList: [
        {
          name: "全部",
          value: ''
        },
        {
          name: "友情链接",
          value: 0
        },
        {
          name: "合作伙伴",
          value: 1
        }
      ],
      list: [],
      form: {
        id: '',
        "name": "",
        "url": "",
        "img": "",
        "page": "",
        "type": ""
      },
      rules: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' },
          { required: true, message: '请填写名称', trigger: 'change' },
        ],
        url: [
          { required: true, message: '请填写页面链接', trigger: 'blur' },
          { required: true, message: '请填写页面链接', trigger: 'change' },
        ],
        img: [
          { required: true, message: '请选择并上传图片', trigger: 'blur' },
          { required: true, message: '请选择并上传图片', trigger: 'change' },
        ],
        page: [
          { required: true, message: '请填写所属页面', trigger: 'blur' },
          { required: true, message: '请填写所属页面', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' },
          { required: true, message: '请选择类型', trigger: 'change' },
        ]
      },
      pageSelectList: []

    }
  },
  created() {
    this.getList();
  },
  mounted() {

  },
  methods: {
    switchStatus(index) {
      this.statusIndex = index;
      this.params['type'] = this.statusList[index]['value']
      this.getList();
    },
    onSearch() {
      // if(this.params['search_val']){
      this.getList();
      // }
    },
    // 下拉选择页面
    getPageSelectList() {
      getPageSelectList().then(res => {
        if (res.code === 0)
          this.pageSelectList = res.data
      })
    },

    onAdd() {
      if (this.pageSelectList.length == 0) {
        this.getPageSelectList();
      }
      this.dialogVisible = true;
    },

    onSave() {
      this.$refs['addForm'].validate().then(res => {
        friendly_save(this.form).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功');
            this.getList();
            this.dialogVisible = false;
          }
        }).then(() => {
          this._initAddForm();
        })
      }).catch(err => {
        this.$message.warning('请完善信息')
      })
    },
    onUpdate() {
      this.$refs['addForm'].validate().then(res => {
        friendly_update(this.form).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功');
            this.getList();
            this.dialogVisible = false;
          }
        }).then(() => {
          this._initAddForm();
        })
      }).catch(err => {
        this.$message.warning('请完善信息')
      })
    },
    // 初始化表单
    _initAddForm() {
      this.$nextTick(() => {
        this.$refs['addForm'].resetFields();
        Object.assign(this.form, this.$options.data().form)
      })
    },
    onEdit(index) {
      console.log(index, this.list[index]['id'])
      for (let key in this.form) {
        this.form[key] = this.list[index][key]
      }
      this.onAdd();
    },
    onDel(index) {
      console.log(index, this.list[index]['id'])
      this.$confirm('此操作将永久删除该渠道, 是否继续?', '删除提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [this.list[index]['id']];
        friendly_delete(ids).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('删除成功');
            this.getList();
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getList() {
      this.loadingData = true;
      friendly_list(this.params).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.list = res['page']['list'];
          this.params['page'] = res['page']['currPage'];
          this.params['limit'] = res['page']['pageSize'];
          this.params['total'] = res['page']['totalCount'];
        }
      }).then(() => {
        this.loadingData = false;
      })
    },
    beforeClose(done) {
      this.$nextTick(() => {
        this.isAdd = true
        this.$refs.addForm.resetFields();
        Object.assign(this.form, this.$options.data().form)
      })
      done();
    },
    onImageChange(value) {
      this.form['img'] = value;
    },
    handleSizeChange(size) {
      this.params.limit = size;
      this.params.page = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.params.page = page;
      this.getList();
    },
  }
}
</script>
 
<style  lang="less" rel="stylesheet/less"  scoped>
.customer-group {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/ .el-select .el-input {
    width: 120px;
  }
}
.customer-content {
  /deep/ .el-form-item {
    margin-bottom: 0px;
  }
  /deep/ .el-form-item__content {
    text-align: left;
  }
}

.pagination {
  text-align: right;
  padding: 20px;
}
</style>